(function() {
      let currentTimestamp = null;
      if (typeof ProductForm === 'undefined') return;
      const originalSubmit = ProductForm.prototype.onSubmitHandler;
      ProductForm.prototype.onSubmitHandler = function(evt) {
        const custom_block = $('.customisation-block input[name="properties[Personalisation Text 1]"]');
        
        if(custom_block.length && custom_block.val().trim().length > 0) {
          currentTimestamp = Date.now().toString();
          console.log('Created timestamp:', currentTimestamp);
        }
        
        return originalSubmit.call(this, evt);
  };

  
  $(document).on('click', '.add-customisation-product button[name="add"]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const $form = $(this).closest('form');
    
    $form.find('input[name="properties[__timestamp]"]').remove();
    
    if(currentTimestamp) {
      console.log('Adding timestamp to customisation form:', currentTimestamp);
      
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[__timestamp]';
      hiddenInput.value = currentTimestamp;
      $form.append(hiddenInput);
    }
    
    setTimeout(() => {
      $(this)[0].click();
    }, 50);
  });
  
  document.addEventListener('click', function(e) {
    const removeButton = e.target.closest('cart-remove-button');
    if (!removeButton) return;
    
    const line = removeButton.dataset.index;
    const $row = $(`#CartDrawer-Item-${line}, #CartItem-${line}`);
    
    console.log('=== Remove button clicked ===');
    console.log('Line:', line);
    console.log('Row found:', $row.length > 0);
    
    if ($row.length === 0) return;
    
    // Check if this row has Personalisation Text 1
    const hasPersonalisation = $row.find('.product-option dt:contains("Personalisation Text 1")').length > 0;
    console.log('Has Personalisation Text 1:', hasPersonalisation);
    
    if (!hasPersonalisation) {
      console.log('No personalisation found, skipping');
      return;
    }
    
    // Check if this is the customisation product itself
    if ($row.hasClass('customisation-product')) {
      console.log('This is a customisation product, skipping auto-removal');
      return;
    }
    
    // Get the personalisation text value
    const personalisationValue = $row.find('.product-option dt:contains("Personalisation Text 1")').next('dd').text().trim();
    console.log('Personalisation value:', personalisationValue);
    
    if (!personalisationValue) {
      console.log('No personalisation value found');
      return;
    }
    
    // Find other items with the same personalisation text (these should be customisation products)
    $('.cart-item').each(function() {
      const $otherRow = $(this);
      const otherPersonalisationValue = $otherRow.find('.product-option dt:contains("Personalisation Text 1")').next('dd').text().trim();
      
      // Skip the current row and rows without personalisation
      if ($otherRow.is($row) || !otherPersonalisationValue) return;
      
      // If same personalisation text, this is likely the customisation product
      if (otherPersonalisationValue === personalisationValue) {
        const customPropKey = $otherRow.attr('prop-key');
        console.log('Found matching customisation product with same text:', personalisationValue);
        console.log('Customisation prop-key:', customPropKey);
        
        if (customPropKey) {
          console.log('Removing customisation product...');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: customPropKey,
              quantity: 0
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Customisation removed successfully:', data);
          })
          .catch(error => {
            console.error('Error removing customisation:', error);
          });
        }
      }
    });
  }, true);
})();